import { useQuery } from "@tanstack/react-query";
import { getWorkOrderNumberPreview } from "@/shared/repositories/WorkOrderRepository";

export const useWorkOrderNumberPreview = (
	assetId: number | null,
	enabled: boolean,
) => {
	return useQuery({
		queryKey: ["workOrderNumberPreview", assetId],
		queryFn: ({ signal }) =>
			getWorkOrderNumberPreview(assetId as number, signal),
		// Invalidation can't refetch it while disabled, same as the old gate.
		meta: { realtime: ["FAB.GetWorkOrderNumberPreview"] },
		enabled: enabled && !!assetId,
		staleTime: 0,
		refetchOnMount: "always",
		refetchOnWindowFocus: "always",
		refetchOnReconnect: "always",
		refetchInterval: 30_000,
	});
};
